import Waterfall from './container';

export default Waterfall;
